import { useEffect } from 'react';
import Navigation from '../components/Navigation';
import ProjectCard from '../components/ProjectCard';
import Footer from '../components/Footer';
import PageTransition from '../components/PageTransition';
import { projects } from '../data/projects';

const Home = () => {
  useEffect(() => {
    // Scroll hint animation
    const projectsScroll = document.querySelector('.projects-scroll');
    let scrollHintShown = false;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting && !scrollHintShown) {
          scrollHintShown = true;
          setTimeout(() => {
            if (projectsScroll) {
              projectsScroll.scrollLeft = 50;
              setTimeout(() => {
                projectsScroll.scrollLeft = 0;
              }, 300);
            }
          }, 500);
        }
      });
    });

    if (projectsScroll) {
      observer.observe(projectsScroll);
    }

    return () => {
      if (projectsScroll) {
        observer.unobserve(projectsScroll);
      }
    };
  }, []);

  const scrollToSection = (e, id) => {
    e.preventDefault();
    const element = document.querySelector(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <PageTransition>
      <Navigation />
      
      <section className="hero">
        <div className="scribble scribble-1">✦</div>
        <div className="scribble scribble-2">↗</div>
        
        <div className="hero-intro animate-in">Hey, I'm a design leader who codes</div>
        
        <h1 className="hero-headline animate-in">
          <span className="line">I don't make</span>
          <span className="line"><span className="accent">pretty mockups.</span></span>
          <span className="line">I ship products</span>
          <span className="line">that make money.</span>
        </h1>

        <div className="hero-metrics animate-in">
          <div className="metric-big">
            <div className="metric-number">₹50L</div>
            <div className="metric-label">Monthly Revenue</div>
          </div>
          <div className="metric-big">
            <div className="metric-number">10K</div>
            <div className="metric-label">Users Served</div>
          </div>
          <div className="metric-big">
            <div className="metric-number">7mo</div>
            <div className="metric-label">To Hit Target</div>
          </div>
          <div className="metric-big">
            <div className="metric-number">85%</div>
            <div className="metric-label">Cost Reduction</div>
          </div>
        </div>

        <div className="hero-note animate-in">
        12 years across design and engineering, with 8+ years building 0→1 digital products. Design leader who codes in React. Former co-founder. Led teams that generated ₹70L+ monthly revenue across grocery delivery, food delivery, and healthcare.
        </div>

        <div className="arrow-scribble">→</div>
      </section>

      <section id="work" className="projects-section">
        <div className="section-label">
          Projects That Made Real Money
          <span className="scroll-hint">Scroll Sideways →</span>
        </div>
        
        <div className="projects-scroll">
          {projects.map(project => (
            <ProjectCard key={project.id} project={project} />
          ))}
          
          <div 
            className="project-card" 
            style={{ 
              minWidth: '400px', 
              background: 'var(--accent)', 
              color: 'white', 
              display: 'flex', 
              alignItems: 'center', 
              justifyContent: 'center', 
              fontSize: '2rem', 
              fontWeight: '900',
              textAlign: 'center',
              cursor: 'pointer'
            }} 
            onClick={(e) => scrollToSection(e, '#contact')}
          >
            Want to see<br/>full case studies?<br/>→ Let's talk
          </div>
        </div>
      </section>

      <section id="about" className="about">
        <div className="about-left">
          <h2>I build 0→1 products that make money</h2>
          <p>
            For 12 years, I've been the person who takes messy requirements and ships MVPs fast.
          </p>
          <p>
           I write React to turn designs into working products—not just proof-of-concepts.I make business decisions, not just design decisions. I don't hand off Figma files—I stay until it ships, iterates, and generates revenue.
          </p>
          <p>
            Led teams of 2-4 designers and 3-5 developers. Built products serving 15K+ users. 
            Currently exploring senior design roles at ambitious product companies.
          </p>
        </div>

        <div className="about-right">
          <h3>What I Do</h3>
          
          <div className="skill-category-title">Design</div>
          <ul className="skill-list">
            <li>Product Strategy & Vision</li>
            <li>UI/UX Design</li>
            <li>User Research & Testing</li>
            <li>Design Systems</li>
            <li>Design Leadership</li>
          </ul>

          <div className="skill-category-title">Code</div>
          <ul className="skill-list">
            <li>React & JavaScript</li>
            <li>HTML/CSS (Expert)</li>
            <li>PHP Laravel</li>
            <li>Responsive Web Design</li>
          </ul>

          <div className="skill-category-title">Business</div>
          <ul className="skill-list">
            <li>0→1 Product Development</li>
            <li>Growth Strategy</li>
            <li>Analytics & Metrics</li>
            <li>Team Building & Leadership</li>
            <li>Product Management</li>
          </ul>
        </div>
      </section>

      <section id="contact" className="contact">
        <h2>Let's build something together</h2>
        <p>Open to senior product design & design-engineering opportunities</p>
        
        {/* OPTION 3: Both Resume + Email */}
        <div className="contact-buttons">
          <a 
            href="/assets/resume.pdf" 
            download="Bosu_Devineni_Resume.pdf"
            className="contact-cta contact-cta-primary"
          >
            Download Resume
          </a>
          
          <a 
            href="mailto:your.email@example.com"
            className="contact-cta contact-cta-secondary"
          >
            Send Email
          </a>
        </div>
      </section>

      <Footer />
    </PageTransition>
  );
};

export default Home;